import { render, staticRenderFns } from "./occupancy.vue?vue&type=template&id=36cb9576&"
import script from "./occupancy.vue?vue&type=script&lang=js&"
export * from "./occupancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports